import script from "./ProfileDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileDrawer.vue?vue&type=script&setup=true&lang=js"

import "./ProfileDrawer.vue?vue&type=style&index=0&id=94ad4f2a&scoped=true&lang=css"

import exportComponent from "/builds/p3839/client-suite/proxima_blue2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94ad4f2a"]])

export default __exports__